import { render, staticRenderFns } from "./IconSvgDocument.vue?vue&type=template&id=91a0d742&scoped=true&"
import script from "./IconSvgDocument.vue?vue&type=script&lang=js&"
export * from "./IconSvgDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a0d742",
  null
  
)

export default component.exports